import classNames from "classnames"
import PropTypes from "prop-types"
import React, { forwardRef } from "react"

const FormRadioButton = forwardRef(
  (
    {
      onChange,
      onBlur,
      name,
      value,
      label,
      labelClassName = "truncate",
      disabled,
      checked,
      compact = false,
    },
    ref
  ) => {
    return (
      <div
        data-design-system="FormRadioButton"
        className={classNames("flex items-center", {
          "w-full": !compact,
        })}
      >
        <input
          className="m-0"
          type="radio"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          checked={checked}
          id={`${name}-${value}`}
          ref={ref}
          disabled={disabled}
        />
        <label
          htmlFor={`${name}-${value}`}
          className={`m-0 ml-2 font-normal text-gray-800 ${labelClassName}`}
        >
          {label}
        </label>
      </div>
    )
  }
)

FormRadioButton.displayName = "FormCheckbox"

FormRadioButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  labelClassName: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  compact: PropTypes.bool,
}

export default FormRadioButton
